import Vue from "vue";
import VueRouter from "vue-router";
import content from "../pages/common/Content.vue"
import home from "../pages/Home.vue"
import onlineMagazine from "../pages/OnlineMagazine.vue"
import onlineAll from "../pages/OnlineAll.vue"
import onlineFeactureStory from "../pages/OnlineFeactureStory.vue"
import onlineSideStory from "../pages/OnlineSideStory.vue"
import onlineColumn from "../pages/OnlineColumn.vue"
import onlineMagazineDetail from "../pages/OnlineMagazineDetail.vue"
import browseOccupations from "../pages/BrowseOccupations.vue"
import findAnOpportunity from "../pages/FindAnOpportunity.vue"
import browseCourses from "../pages/BrowseCourses.vue"
import selfAssessment from "../pages/SelfAssessment.vue"
import jobDetail from "../pages/jobDetail.vue"
// import jobSearch from "../pages/jobSearch.vue"
import coursesDetail from "../pages/coursesDetail.vue"
import courseDetailCef from "../pages/courseDetailCef.vue"
import courseDetailQr from "../pages/courseDetailQr.vue"
import eightCentres from "../pages/EightCentres.vue"
import centreDetail from "../pages/centreDetail.vue"
import occupationDetails from "../pages/OccupationDetails.vue"
import selfSkillInfo from "../pages/SelfSkillInfo.vue"
import selfSkillTopic from "../pages/SelfSkillTopic.vue"
import InterestAssessment from "../pages/InterestAssessment.vue"
import InterestAssessmentTopic from "../pages/InterestAssessmentTopic.vue"
import careerMatches from "../pages/careerMatches.vue"
import backgroundInfo from "../pages/backgroundInfo.vue"
import backgroundTopic from "../pages/backgroundTopic.vue"
import aboutUs from "../pages/aboutUs.vue"
import disclaimer from "../pages/Disclaimer.vue"
import privacyPolicy from "../pages/PrivacyPolicy.vue"
import siteMap from "../pages/SiteMap.vue"
import resources from "../pages/Resources.vue"
import feedback from "../pages/Feedback.vue"
import ReratedCourses from "../pages/ReratedCourses.vue"
import ReratedCoursesT from "../pages/ReratedCoursesT.vue"
import ReratedCoursesJ from "../pages/ReratedCoursesJ.vue"
import ReratedCoursesC from "../pages/ReratedCoursesC.vue"
import RelatedVacancies from "../pages/RelatedVacancies.vue"
import RelatedOccupations from "../pages/RelatedOccupations.vue"
import RelatedOccupationsJ from "../pages/RelatedOccupationsJ.vue"
import RelatedOccupationsT from "../pages/RelatedOccupationsT.vue"

Vue.use(VueRouter);

const routes = [{
        path: "/main",
        name: "main",
        component: content,
        children: [{
                path: '/home',
                name: 'home',
                component: home,
                meta: {
                    title: 'Home',
                    breadcrumbs: [
                        { to: '/', text: 'Home' }
                    ]
                }
            },{
                path: '/home/:preview',
                name: 'home',
                component: home,
                meta: {
                    title: 'Home',
                    breadcrumbs: [
                        { to: '/', text: 'Home' }
                    ]
                }
            },
            {
                path: '/magazine',
                name: 'onlineMagazine',
                component: onlineMagazine,
                meta: {
                    title: 'Explorer_title',
                    isUseCache: false, 
              
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/magazine', text: 'Online Magazine' }
                    ]

                }
            },
            {
                path: '/magazine/:magazineId',
                name: 'onlineMagazine',
                component: onlineMagazine,
                meta: {
                    title: 'Explorer_title',
                    isUseCache: false, 
                
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/magazine', text: 'Online Magazine' }
                    ]

                }
            },
            {
                path: '/onlineAll',
                name: 'onlineAll',
                component: onlineAll,
                meta: {
                    title: 'OnlineAll',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/onlineAll', text: 'OnlineAll' }
                    ]

                }
            },
            {
                path: '/onlineFeactureStory',
                name: 'onlineFeactureStory',
                component: onlineFeactureStory,
                meta: {
                    title: 'Explorer_title',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/onlineFeactureStory', text: 'Online Magazine' }
                    ]

                }
            },
            {
                path: '/onlineSideStory',
                name: 'onlineSideStory',
                component: onlineSideStory,
                meta: {
                    title: 'Explorer_title',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/onlineSideStory', text: 'Online Magazine' }
                    ]

                }
            },
            {
                path: '/onlineColumn',
                name: 'onlineColumn',
                component: onlineColumn,
                meta: {
                    title: 'Explorer_title',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/onlineColumn', text: 'Online Magazine' }
                    ]

                }
            },
           
            {
                path: '/onlineMagazineDetail/:id',
                name: 'onlineMagazineDetail',
                component: onlineMagazineDetail,
                meta: {
                    title: 'Explorer_title',
                    isUseCache:true,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/magazine', text: 'Online Magazine' },
                        { to: '/magazine', text: '' ,isData:true},
                        { to: '/onlineMagazineDetail', text: '' ,isData:true}
                    ]

                }
            },
           
            {
                path: '/onlineMagazineDetail/:id/:preview',
                name: 'onlineMagazineDetail',
                component: onlineMagazineDetail,
                meta: {
                    title: 'Explorer_title',
                    isUseCache:true,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/magazine', text: 'Online Magazine' }
                    ]

                }
            }, {
                path: '/browseOccupations',
                name: 'browseOccupations',
                component: browseOccupations,
                meta: {
                    title: 'Careers_title',
                    isUseCache:false,//true
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseOccupations', text: 'Browse Occupations' }
                    ]
                }
            }, {
                path: '/browseOccupations/:magazineId',
                name: 'browseOccupations',
                component: browseOccupations,
                meta: {
                    title: 'Careers_title',
                    isUseCache:false,//true
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseOccupations', text: 'Browse Occupations' }
                    ]
                }
            }, {
                path: '/findAnOpportunity',
                name: 'findAnOpportunity',
                component: findAnOpportunity,
                meta: {
                    title: 'Find a Job Opportunity',
                    isUseCache: false, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/findAnOpportunity', text: 'Find a Job Opportunity' }
                    ]
                }
            }, {
                path: '/selfAssessment',
                name: 'selfAssessment',
                component: selfAssessment,
                meta: {
                    title: 'Self-Assessment_title',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/selfAssessment', text: 'Self-Assessment' }
                    ]
                }
            }, {
                path: '/jobDetail/:id',
                name: 'jobDetail',
                component: jobDetail,
                meta: {
                    title: 'Find a Job Opportunity',
                    isUseCache: false, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/findAnOpportunity', text: 'Find a Job Opportunity' },
                        { to: '/jobDetail', text: '' ,isData:true}
                    ]
                }
            }, {
                path: '/coursesDetail',
                name: 'coursesDetail',
                component: coursesDetail,
                meta: {
                    title: 'Browse Courses',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/BrowseCourses', text: 'Browse Courses' }
                    ]
                }
            }, {
                path: '/coursesDetail/:dataSource/:key',
                name: 'coursesDetail',
                component: coursesDetail,
                meta: {
                    title: 'Browse Courses',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/BrowseCourses', text: 'Browse Courses' },
                        { to: '/coursesDetail', text: '' ,isData:true}
                    ]
                }
            }, {
                path: '/courseDetailCef/:dataSource/:key',
                name: 'courseDetailCef',
                component: courseDetailCef,
                meta: {
                    title: 'Browse Courses',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/BrowseCourses', text: 'Browse Courses' },
                        { to: '/courseDetailCef', text: '' ,isData:true}
                    ]
                }
            }, {
                path: '/courseDetailQr/:dataSource/:key',
                name: 'courseDetailQr',
                component: courseDetailQr,
                meta: {
                    title: 'Browse Courses',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/BrowseCourses', text: 'Browse Courses' },
                        { to: '/courseDetailQr', text: '' ,isData:true}
                    ]
                }
            }, {
                path: '/occupationDetails/:id',
                name: 'occupationDetails',
                component: occupationDetails,
                meta: {
                    title: 'Careers_title',
                    isUseCache:false,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseOccupations', text: 'Browse Occupations' },
                        { to: '/occupationDetails', text: '' ,isData:true}
                    ]
                }
            },
                {
                path: '/BrowseCourses',
                name: 'BrowseCourses',
                component: browseCourses,
                meta: {
                    title: 'Browse Courses',
                    isUseCache: false, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/BrowseCourses', text: 'Browse Courses' }
                    ]
                }
            },
               {
                path: '/BrowseCourses/:keyword',
                name: 'BrowseCourses',
                component: browseCourses,
                meta: {
                   title: 'Browse Courses',
                   isUseCache: false, 
                   breadcrumbs: [
                       { to: '/', text: 'Home' },
                       { to: '/BrowseCourses', text: 'Browse Courses' }
                   ]
               }
           },
                {
                path: '/selfSkillInfo',
                name: 'selfSkillInfo',
                component: selfSkillInfo,
                meta: {
                    title: 'Skill-Career Quiz',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/selfSkillInfo', text: 'Skill-Career Quiz' }
                    ]
                }
            },
                {
                path: '/selfSkillTopic',
                name: 'selfSkillTopic',
                component: selfSkillTopic,
                meta: {
                    title: 'Skill-Career Quiz',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/selfSkillTopic', text: 'Skill-Career Quiz' }
                    ]
                }
            },
                {
                path: '/InterestAssessment',
                name: 'InterestAssessment',
                component: InterestAssessment,
                meta: {
                    title: 'Interest-Career Quiz',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/InterestAssessment', text: 'Interest-Career Quiz' }
                    ]
                }
            },

            {
                path: '/InterestAssessmentTopic',
                name: 'InterestAssessmentTopic',
                component: InterestAssessmentTopic,
                meta: {
                    title: 'Interest-Career Quiz',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/InterestAssessmentTopic', text: 'Interest-Career Quiz' }
                    ]
                }
            },
            {
                path: '/careerMatches',
                name: 'careerMatches',
                component: careerMatches,
                meta: {
                    title: 'Your Career Matches',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/careerMatches', text: 'Your Career Matches' }
                    ]
                }
            },
                {
                path: '/backgroundInfo',
                name: 'backgroundInfo',
                component: backgroundInfo,
                meta: {
                    title: 'Background-Career Quiz',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/backgroundInfo', text: 'Background-Career Quiz' }
                    ]
                }
            },
                {
                path: '/backgroundTopic',
                name: 'backgroundTopic',
                component: backgroundTopic,
                meta: {
                    title: 'Background-Career Quiz',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/backgroundTopic', text: 'Background-Career Quiz' }
                    ]
                }
            },
                {
                path: '/aboutUs',
                name: 'aboutUs',
                component: aboutUs,
                meta: {
                    title: 'About Us',
                    isUseCache: true, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/aboutUs', text: 'About Us' }
                    ]
                }
            },
                {
                path: '/disclaimer',
                name: 'disclaimer',
                component: disclaimer,
                meta: {
                    title: 'Disclaimer',
                    isUseCache: true, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/disclaimer', text: 'Disclaimer' }
                    ]
                }
            },
                {
                path: '/privacyPolicy',
                name: 'privacyPolicy',
                component: privacyPolicy,
                meta: {
                    title: 'Privacy Policy',
                    isUseCache: true, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/privacyPolicy', text: 'Privacy Policy' }
                    ]
                }
            },
                {
                path: '/siteMap',
                name: 'siteMap',
                component: siteMap,
                meta: {
                    title: 'siteMap',
                    isUseCache: true, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/siteMap', text: 'siteMap' }
                    ]
                }
            },

                {
                path: '/resources',
                name: 'resources',
                component: resources,
                meta: {
                    title: 'Resources',
                    
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/resources', text: 'Resources' }
                    ]
                }
            },

                {
                path: '/feedback',
                name: 'feedback',
                component: feedback,
                meta: {
                    title: 'Feedback',
                    isUseCache: true, 
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/feedback', text: 'Feedback' }
                    ]
                }
            },
            
            {
                path: '/ReratedCourses',
                name: 'ReratedCourses',
                component: ReratedCourses,
                meta: {
                    title: 'RelatedCourses',
                    isUseCache:true,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseOccupations', text: 'Browse Occupations'},
                        { to: '/occupationDetails', text: 'occupationDetails',isData:true},
                        { to: '/ReratedCourses', text: 'RelatedCourses'}
                    ]
                }
            },
            {
                path: '/ReratedCoursesT',
                name: 'ReratedCoursesT',
                component: ReratedCoursesT,
                meta: {
                    title: 'RelatedCourses',
                    isUseCache:true,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseCourses', text: 'Browse Courses'},
                        { to: '/coursesDetail', text: 'coursesDetail',isData:true},
                        { to: '/ReratedCoursesT', text: 'RelatedCourses'}
                    ]
                }
            },
            {
                path: '/ReratedCoursesJ',
                name: 'ReratedCoursesJ',
                component: ReratedCoursesJ,
                meta: {
                    title: 'RelatedCourses',
                    isUseCache:true,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseCourses', text: 'Browse Courses'},
                        { to: '/findAnOpportunity', text: 'Find a Job Opportunity',isData:true},
                        { to: '/ReratedCoursesJ', text: 'RelatedCourses'}
                    ]
                }
            },
            {
                path: '/ReratedCoursesC',
                name: 'ReratedCoursesC',
                component: ReratedCoursesC,
                meta: {
                    title: 'RelatedCourses',
                    isUseCache:true,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseCourses', text: 'Browse Courses'},
                        { to: '/coursesDetail', text: 'coursesDetail',isData:true},
                        { to: '/ReratedCoursesC', text: 'RelatedCourses'}
                    ]
                }
            },
            {
                path: '/RelatedVacancies',
                name: 'RelatedVacancies',
                component: RelatedVacancies,
                meta: {
                    title: 'RelatedJobOpportunities',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseOccupations', text: 'Browse Occupations' },
                        { to: '/occupationDetails', text: 'OccupationsDetail' ,isData:true},
                        { to: '/RelatedVacancies', text: 'RelatedJobOpportunities' }
                    ]
                }
            },
            {
                path: '/RelatedOccupations/:magazineId',
                name: 'RelatedOccupations',
                component: RelatedOccupations,
                meta: {
                    title: 'Related Occupations',
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/magazine', text: 'Online Magazine' },
                        { to: '/onlineMagazineDetail', text: 'online magazineDetail', isData:true },
                        { to: '/RelatedOccupations', text: 'Related Occupations' }
                    ]
                }
            },
            {
                path: '/RelatedOccupationsJ',
                name: 'RelatedOccupationsJ',
                component: RelatedOccupationsJ,
                meta: {
                    title: 'Related Occupations',
                    isUseCache: false,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/findAnOpportunity', text: 'Find a Job Opportunity' },
                        { to: '/findAnOpportunity', text: 'Find a Job Opportunity', isData:true },
                        { to: '/RelatedOccupationsJ', text: 'Related Occupations' }
                    ]
                }
            },
            {
                path: '/RelatedOccupationsT',
                name: 'RelatedOccupationsT',
                component: RelatedOccupationsT,
                meta: {
                    title: 'Related Occupations',
                    isUseCache: false,
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/browseCourses', text: 'Browse Courses'},
                        { to: '/coursesDetail', text: 'Browse Courses',isData:true},
                        { to: '/RelatedOccupationsT', text: 'Related Occupations'}
                    ]
                }
            },
            {
                path: '/eightcentres',
                name: 'eightCentres',
                component: eightCentres,
                meta: {
                    title: 'Eight Centres',
                    isUseCache: false, 
              
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/eightcentres', text: 'hongKongEightCentres' }
                    ]

                }
            },
            {
                path: '/eightcentres/:id',
                name: 'centreDetail',
                component: centreDetail,
                meta: {
                    title: 'Detail - Eight Centres',
                    isUseCache: false, 
              
                    breadcrumbs: [
                        { to: '/', text: 'Home' },
                        { to: '/eightcentres', text: 'hongKongEightCentres' }
                    ]

                }
            },

        ]
    },
    {
        path: '/',
        redirect: '/home'
    }
]

var router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    }
})


export default router;